module.exports = __webpack_public_path__ + "assets/img/help_noeBtn.adea94dd.png";